import { createApp } from 'vue'

//import AxiosPlugin from 'vue-axios-cors';

import App from './App.vue'

import router  from './router'
//Vue.use(AxiosPlugin)
createApp(App).use(router).mount('#app')
